import { render } from "./AgeControl.vue?vue&type=template&id=40377924"
import script from "./AgeControl.vue?vue&type=script&lang=js"
export * from "./AgeControl.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__